require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-archive-people-luke-fagg.json") })
        }
      }, "path---people-archive-people-luke-fagg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-archive-people-luke-fagg!./.cache/json/people-archive-people-luke-fagg.json
// module id = 1447
// module chunks = 231608221292675